export const useAssignmentDataStore = (
  classroomId: string,
  assignmentId: string
) => {
  return useAssignmentData(classroomId, assignmentId)();
};
